import { render, staticRenderFns } from "./RenewalInplayDetail.vue?vue&type=template&id=4b477dfb&scoped=true"
import script from "./RenewalInplayDetail.vue?vue&type=script&lang=js"
export * from "./RenewalInplayDetail.vue?vue&type=script&lang=js"
import style0 from "./RenewalInplayDetail.vue?vue&type=style&index=0&id=4b477dfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b477dfb",
  null
  
)

export default component.exports